/**
 * Performance (QM-D12-001/002/003 screens): KPI tiles, channels, observed vs modelled revenue, funnel, attribution chain.
 * Behind the server-evaluated `attribution.dashboard` flag (default off): off, unknown or failed -> the ordinary
 * not-found screen (and no nav entry), so nothing about the feature shows until staff enable it for the tenant.
 */
import { useMemo } from 'react';
import { Heading, Loading, PageHeader } from '@qm/ui';
import { useWorkspaceName } from '../_shared/ListScreen';
import { useApp } from '../../../lib/app-context';
import { KPI_DASHBOARD_FLAG, useFlag } from '../../../lib/flags';
import { createPerformanceSource } from '../../../performance/logic';
import { PerformanceView } from '../../../performance/PerformanceView';
import { NotFoundScreen } from '../../../shell/RouteStates';

export function PerformancePage() {
  const { t } = useApp();
  const state = useFlag(KPI_DASHBOARD_FLAG);
  if (state === 'off') return <NotFoundScreen />;
  if (state === 'loading') {
    return (
      <section className="qm-page" aria-labelledby="page-title">
        <Heading level={1} id="page-title">{t('attribution.perf.title')}</Heading>
        <Loading label={t('common.loading')} />
      </section>
    );
  }
  return <Performance />;
}

function Performance() {
  const { t, locale } = useApp();
  const source = useMemo(() => createPerformanceSource({ kind: 'tenant' }), []);
  const workspace = useWorkspaceName();
  return (
    <section className="qm-page" aria-labelledby="page-title">
      <PageHeader eyebrow={workspace} title={t('attribution.perf.title')} intro={t('attribution.perf.intro')} />
      <PerformanceView source={source} t={t} locale={locale} integrationsHref="/integrations" />
    </section>
  );
}
